<template>
  <b-sidebar id="add-new-subject-sidebar" :visible="isAddNewSchoolSidebarActive" bg-variant="white"
    sidebar-class="sidebar-lg" shadow backdrop no-header right @hidden="resetForm"
    @change="(val) => $emit('update:is-add-new-school-sidebar-active', val)">
    <template #default="{ hide }">
      <div class="
            d-flex
            justify-content-between
            align-items-center
            content-sidebar-header
            px-2
            py-1
          ">
        <h5 class="mb-0">{{ school_data.request_id ? "Create School from Request" : "Add School" }}</h5>
        <feather-icon class="ml-1 cursor-pointer" icon="XIcon" size="16" @click="hide" />
      </div>
      <zape-gallery-model :props_hideShowModel="showImageModel" @modelClose="modelClose"
        @saveCategoryImage="saveImage" />
      <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
        <b-form class="p-2" @submit.prevent="handleSubmit(onSubmit)" @reset.prevent="resetForm">
          <b-alert v-if="prefill && prefill.admin_email && school_data.request_id" show variant="info" class="p-1">
            <small>Creating the school approves the request and makes <strong>{{ prefill.admin_email }}</strong>
              the school admin. They log in to the school portal with this email.</small>
          </b-alert>
          <validation-provider #default="validationContext" name="School Name" rules="required">
            <b-form-group label="School Name" label-for="School Name">
              <b-form-input id="School-Name" v-model="school_data.school_name" autofocus
                :state="getValidationState(validationContext)" trim />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <validation-provider #default="validationContext" name="Number of Staff" rules="required|numeric|min_value:1">
            <b-form-group label="Number of Staff" label-for="staff-count">
              <b-form-input id="staff-count" v-model.number="school_data.staff_count" type="number" min="1"
                :state="getValidationState(validationContext)" placeholder="Enter number of staff" />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <validation-provider #default="validationContext" name="Premium Seats" rules="required|numeric|min_value:0">
            <b-form-group label="Premium Seats" label-for="premium-seats"
              description="Students get a premium seat automatically while seats are free.">
              <b-form-input id="premium-seats" v-model.number="school_data.premium_seats" type="number" min="0"
                :state="getValidationState(validationContext)" placeholder="Enter number of premium seats" />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <validation-provider #default="validationContext" name="Package" :rules="packageRequired ? 'required' : ''">
            <b-form-group label="Package" label-for="school-package"
              :state="getValidationState(validationContext)">
              <v-select id="school-package" v-model="school_data.package_id" :options="packageOptions"
                label="label" :reduce="option => option.id" :loading="packagesLoading"
                :clearable="!packageRequired" placeholder="Select package" />
              <small v-if="packageRequired && !school_data.package_id" class="text-muted">
                A package is required when premium seats are greater than 0.
              </small>

              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <template v-if="getFileExtensionFromUrl(school_data.school_img) == 'json'">
            <LottieView :url="school_data.school_img" :forEditTopics="true" :key="keyForLottie" />
          </template>
          <template v-else-if="getFileExtensionFromUrl(school_data.school_img) == 'lottie'">
            <DoLottieView :url="school_data.school_img" :forEditTopics="true" :id="`school_img_${uuidv4()}`"
              :key="keyForLottie" />
          </template>
          <template v-else>
            <img style="width: 200px; height: 150px" :src="school_data.school_img" />
          </template>

          <br />
          <br />
          <div class="d-flex gap-2">
            <b-button variant="primary" @click="showgalleryimage">
              <span class="d-none d-sm-inline">Image gallery</span>
            </b-button>
            <upload-image @saveUploadImage="saveUploadImage" />
          </div>
          <div class="d-flex bg-light text-light align-items px-3 py-2"
            style="position: absolute; bottom: 0%; left: 0%; width: 100%">
            <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" type="submit" @click="hide"
              :disabled="submitbutton">
              Add
            </b-button>
            <b-button v-ripple.400="'rgba(186, 191, 199, 0.15)'" type="button" style="margin-left: 10px"
              variant="outline-secondary" @click="hide">
              Cancel
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar,
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BButton,
  BCol,
  BFormFile,
  BFormSelect,
  BAlert,
} from "bootstrap-vue";
import vSelect from "vue-select";
import axios from "axios";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import Ripple from "vue-ripple-directive";
import LottieView from "../../../components/question/LottieView.vue";
import DoLottieView from "../../../components/question/DoLottieView.vue";
import { v4 as uuidv4 } from 'uuid';
export default {
  components: {
    ZapeGalleryModel: () => import("../../../components/Model/ZapeGalleryModel.vue"),
    UploadImage: () => import("../../../components/Model/UploadImage.vue"),
    BSidebar,
    DoLottieView,
    LottieView,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    BFormFile,
    BAlert,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    uuidv4
  },
  directives: {
    Ripple,
  },
  model: {
    prop: "isAddNewSchoolSidebarActive",
    event: "update:is-add-new-school-sidebar-active",
  },
  props: {
    isAddNewSchoolSidebarActive: {
      type: Boolean,
      required: true,
    },
    // Prefill from a school request: { request_id, school_name, staff_count, premium_seats, package_id, package_name }
    prefill: {
      type: Object,
      required: false,
      default: null,
    },
    //   classId: {
    //     type: String,
    //     required: true,
    //   },
  },
  data() {
    return {
      school_data: this.emptySchoolData(),
      post_school_data: "",
      showImageModel: false,
      keyForLottie: 0,
      packages: [],
      packagesLoading: false,
    };
  },
  computed: {
    packageRequired() {
      return Number(this.school_data.premium_seats) > 0;
    },
    packageOptions() {
      const options = this.packages.map((p) => ({
        ...p,
        label: [p.name, p.billing_cycle, p.country_code].filter(Boolean).join(" · "),
      }));
      // Keep a requested package visible even if it is no longer active
      const selectedId = this.school_data.package_id;
      if (selectedId && !this.packagesLoading && !options.some((o) => o.id === selectedId)) {
        const name = (this.prefill && this.prefill.package_name) || selectedId;
        options.unshift({ id: selectedId, label: name + " (inactive)" });
      }
      return options;
    },
    submitbutton() {
      return !(
        this.school_data.school_name.length > 0 &&
         this.school_data.staff_count > 0 &&
        this.school_data.premium_seats !== "" &&
        this.school_data.premium_seats !== null &&
        Number(this.school_data.premium_seats) >= 0 &&
        (!this.packageRequired || !!this.school_data.package_id) &&
        this.school_data.school_img.length > 0 &&
        this.school_data.school_img !== "https://t4.ftcdn.net/jpg/02/07/87/79/360_F_207877921_BtG6ZKAVvtLyc5GWpBNEIlIxsffTtWkv.jpg"
      );
    },
  },
  watch: {
    isAddNewSchoolSidebarActive(val) {
      if (val) {
        if (!this.packages.length) this.getPackages();
        this.applyPrefill();
      }
    },
  },
  created() {
    this.getPackages();
  },
  methods: {
    emptySchoolData() {
      return {
        school_name: "",
        staff_count: null,
        premium_seats: 0,
        package_id: null,
        request_id: null,
        school_img:
          "https://t4.ftcdn.net/jpg/02/07/87/79/360_F_207877921_BtG6ZKAVvtLyc5GWpBNEIlIxsffTtWkv.jpg",
      };
    },
    applyPrefill() {
      if (!this.prefill) return;
      const p = this.prefill;
      this.school_data = {
        ...this.emptySchoolData(),
        school_name: p.school_name || "",
        staff_count: p.staff_count ? Number(p.staff_count) : null,
        premium_seats: p.premium_seats ? Number(p.premium_seats) : 0,
        package_id: p.package_id || null,
        request_id: p.request_id || null,
        school_img: p.school_img || this.emptySchoolData().school_img,
      };
    },
    getPackages() {
      this.packagesLoading = true;
      axios
        .get(process.env.VUE_APP_API_URL + "/school/packages", {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("_t"),
          },
        })
        .then((response) => {
          this.packages = response.data.packages || [];
        })
        .catch((error) => {
          console.log("error", error);
        })
        .finally(() => {
          this.packagesLoading = false;
        });
    },
    getModuleTypeOptions() {
      return [
        { label: 'TopicPlay', value: 'Topic Play' },
        { label: 'ModulePlay', value: 'Module Play' }
      ];
    },
    uuidv4,
    getFileExtensionFromUrl(url) {
      if (!url) return '';
      const path = url.split('?')[0].split('#')[0];
      const extension = path.split('.').pop();

      if (extension === path) return '';

      return extension;
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    resetForm() {
      this.school_data = this.emptySchoolData();
      this.validated = false;
    },
    onSubmit() {
      const payload = { ...this.school_data };
      payload.premium_seats = Number(payload.premium_seats) || 0;
      if (!payload.package_id) payload.package_id = null;
      if (!payload.request_id) delete payload.request_id;
      this.$emit("sendschooldata", payload);
    },
    saveUploadImage(url) {
      this.school_data.school_img = url;
    },
    modelClose(modelState) {
      this.showImageModel = modelState;
    },
    saveImage(url) {
      this.school_data.school_img = url;
    },
    showgalleryimage() {
      this.showImageModel = true;
    },
  },
};
</script>